import { Suspense } from "react";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import Main from "./layout/Main";
import routes from "./routes";

const RouteFallback = () => (
	<div className="min-h-screen w-full bg-[#1a1820] flex items-center justify-center">
		<p className="font-Poppins text-white/60">Loading…</p>
	</div>
);

function App() {
	return (
		<BrowserRouter>
			<Suspense fallback={<RouteFallback />}>
				<Routes>
					{routes.map((route) => (
						<Route
							key={route.path}
							path={route.path}
							element={
								<Main>
									<route.component />
								</Main>
							}
						/>
					))}
					<Route path="*" element={<Navigate to="/" replace />} />
				</Routes>
			</Suspense>
		</BrowserRouter>
	);
}

export default App;
